import { Link } from 'react-router-dom';

export default function Unauthorized() {
  return (
    <div className="care-page care-page--narrow">
      <div className="care-state-panel">
        <Link to="/" className="care-button-link">
          Back to dashboard
        </Link>
      </div>
    </div>
  );
}
